class Log {

    /**
     * Color and consistent console logging wrapper.
     *
     * @since 2.0.0
     * @method it
     * @param string|mixed message is the message we will log
     * @param string tag is a logging category for colorization
     * @param string color is a custom color for the log
     * @return void
     */
    constructor(message, tag, color) {

        // Rhinox Maximize!
        var self = this;
        var raw  = message;

        // If we had a timer, do some special processing
        if ('timer' === tag) {

            // Set some default tag for colorization
            tag = 'log';

            // Calculate the time in seconds (we receive milliseconds
            let time = parseFloat((message / 1000).toFixed(3));

            // Define our own timer message
            message = 'Took ' + time + 's.';

        }

        // Manage our log entry parts
        message = message || '[Error] An unknown action has occurred.';

        // Default to a tag if one is missing
        if (!tag) tag = 'log';

        // Aply the tag to the message
        message = '[' + tag[0].toUpperCase() + '] ' + message;

        // Try to color code all of our tags uniformly
        if (!color && tag) color = this.getColor(tag);

        // Declare and initialize
        var log   = '%c ' + message;
        var style = 'color: #' + color + ';';

        // Formulate debug logs a bit differently
        if ('debug' === tag) {
            console.trace('%c [Debug] ', style, raw);
            return;
        }

        // Call up our console (use color if one was set)
        if ('function' === typeof console.groupCollapsed &&
            'function' === typeof console.trace &&
            'function' === typeof console.groupEnd) {

            // Store our trace in a collapsed group
            console.groupCollapsed(log, style);
            console.trace('...');
            console.groupEnd();

        } else {

            // Normal, dumb log
            console.log(log, style);

        }
    }

    /**
     * Record of console log colors for various types of logs.
     *
     * @since 2.0.0
     * @method getColor
     * @param string tag The tag to cross-reference
     * @return string The hex color value (without "#")
     */
    getColor(tag) {
        // Declare and initialize
        var colors = {
            ajax:    '3f51b5',
            error:   '9c27b0',
            fail:    'f7412d',
            init:    'cdde20',
            log:     '89c541',
            save:    '6734ba',
            success: '48b04b'
        };

        // Return the color if we have it
        if (tag in colors) return colors[tag];
    }

    /**
     * Generate a random color.
     *
     * @since 2.0.0
     * @method color
     * @return string Random hex color
     * @link https://www.paulirish.com/2009/random-hex-color-code-snippets/
     */
    getRandomColor() {
        // Generate the color
        var color = Math.floor(Math.random() * 16777215).toString(16);

        // Throw back the color (we always need 6)
        return ('c33d3d' + color).slice(-6);
    }

}

export default Log;